import { useEffect, useState } from "react";

/** True once the page has scrolled past `threshold` px - used to solidify the navbar. */
export const useScrolled = (threshold = 24): boolean => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > threshold);
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [threshold]);

  return scrolled;
};
